import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash, IconZoomIn, IconEye } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { formatDate } from '../../../helpers/formatDate';

const DatatableRiskActivityTargets = (props) => {
  // console.log(props);
  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-success"
            type="button"
            title="Detil Info Kegiatan & Sasaran"
            onClick={() => handleChangePage(`/risk-register/${row.id}`)}
          >
            <IconZoomIn stroke={2} />
          </button>
          {props.role === 'Administrator' ||
            props.role === 'Kelompok Kerja' ||
            props.role === 'Surveior Internal' ? (
            <>
              <button
                className="btn btn-sm btn-outline-warning"
                type="button"
                title="Edit Kegiatan dan Sasaran"
                onClick={() => props.handleEdit(row)}
              >
                <IconEdit stroke={2} />
              </button>
              <button
                className="btn btn-sm btn-outline-danger"
                type="button"
                title="Hapus Kegiatan dan Sasaran"
                onClick={() => props.handleHapus(row.id)}
              >
                <IconTrash stroke={2} />
              </button>
            </>
          ) : (
            ''
          )}
        </>
      ),
    },
    {
      name: 'Nama Kegiatan',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={
          containerStyle
        }>
          {row.name}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: 'normal',
      },
    },
    {
      name: 'Tujuan Kegiatan (S.M.A.R.T)',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={
          containerStyle
        }>
          {row.goals}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: 'normal',
      },
    },
    {
      name: 'Unit Kerja',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            {row.user?.risk_division?.namaDivision}
          </div>
        </>
      ),
    },
    {
      name: 'Jabatan',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            {row.user?.jabatan}
          </div>
        </>
      ),
    },
    // {
    //   name: 'Kategori Risiko',
    //   minWidth: '125px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //         {row.riskCategory === 'Klinis'
    //           ? 'Klinis'
    //           : row.riskCategory === 'NonKlinis'
    //           ? 'Non Klinis'
    //           : ''}
    //       </div>
    //     </>
    //   ),
    // },
    {
      name: 'Tanggal Dibuat',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            {formatDate(row.createdAt)}
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <DataTable
          columns={columns}
          data={props?.listRiskActivityTargets}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Kegiatan dan Sasaran"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableRiskActivityTargets;
